@if (isEditing) {
    <div class="o-grid">
        @if (this.content?.globalCtm && getFormArray('globalCtm')?.controls) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'Global CTMs'"
                        [description]="''"
                        [icon]="'people'"
                        class="expansion-panel-m-0"
                        [attr.data-cy]="'globalCtmExpansion'"
                    >
                        @for (
                            globalCtmFormGroup of getFormArray('globalCtm')?.controls;
                            track globalCtmFormGroup;
                            let i = $index
                        ) {
                            <div class="o-grid__row">
                                <div class="o-grid__field">
                                    <mds-text-field
                                        id="globalCtm{{ i }}"
                                        [formCtrl]="getFullNameFormControl(globalCtmFormGroup)"
                                        [placeholder]="'Type here...'"
                                        [appearance]="'outline'"
                                        [inputType]="'text'"
                                        [label]="'Global CTM'"
                                        [textFieldWidth]="'100%'"
                                        (input)="emitStringChange($event, { id: 'globalCtm_' + i })"
                                    />
                                </div>
                                <div class="delete-icon">
                                    <mds-icon-button
                                        id="globalCtmTrash{{ i }}"
                                        [icon]="'delete'"
                                        (clickEvent)="removePerson('globalCtm', i)"
                                        [tooltip]="'Delete'"
                                        class="delete-btn danger outline"
                                    ></mds-icon-button>
                                </div>
                            </div>
                        }

                        <ng-container
                            [ngTemplateOutlet]="AddPerson"
                            [ngTemplateOutletContext]="{
                                $implicit: {
                                    roleName: 'globalCtm',
                                },
                            }"
                        />
                    </mds-expansion-panel>
                </div>
            </div>
        }
        @if (this.content?.regionalCtms && getFormArray('regionalCtms')?.controls) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'Regional CTMs'"
                        [description]="''"
                        [icon]="'people'"
                        class="expansion-panel-m-0"
                        [attr.data-cy]="'regionalCtmsExpansion'"
                    >
                        @for (
                            regionalCtmFormGroup of getFormArray('regionalCtms')?.controls;
                            track regionalCtmFormGroup;
                            let i = $index
                        ) {
                            <div class="o-grid__row">
                                <div class="o-grid__field half">
                                    <mds-text-field
                                        id="regionalCtms{{ i }}"
                                        [formCtrl]="getFullNameFormControl(regionalCtmFormGroup)"
                                        [placeholder]="'Type here...'"
                                        [appearance]="'outline'"
                                        [inputType]="'text'"
                                        [label]="'Regional CTM'"
                                        [textFieldWidth]="'100%'"
                                        (input)="emitStringChange($event, { id: 'regionalCtms_' + i })"
                                    />
                                </div>
                                <div class="o-grid__field third">
                                    <mds-dropdown
                                        id="regionalCtmsRegions{{ i }}"
                                        [formCtrl]="getRegionsFormControl(regionalCtmFormGroup)"
                                        appearance="outline"
                                        [multiple]="true"
                                        [label]="'Regions'"
                                        [options]="regionsForView"
                                        [placeholder]="'Select region'"
                                        [filterable]="true"
                                        (selectionChange)="
                                            regionsSelectionChange($event, 'regionalCtms_' + i + '-Regions')
                                        "
                                    />
                                </div>
                                <div class="delete-icon">
                                    <mds-icon-button
                                        id="regionalCtmsTrash{{ i }}"
                                        [icon]="'delete'"
                                        (clickEvent)="removePerson('regionalCtms', i)"
                                        [tooltip]="'Delete'"
                                        class="delete-btn danger outline"
                                    ></mds-icon-button>
                                </div>
                            </div>
                        }
                        <ng-container
                            [ngTemplateOutlet]="AddPerson"
                            [ngTemplateOutletContext]="{
                                $implicit: {
                                    roleName: 'regionalCtms',
                                },
                            }"
                        />
                    </mds-expansion-panel>
                </div>
            </div>
        }
        @if (this.content?.pc && getFormArray('pc')?.controls) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'PCs'"
                        [description]="''"
                        [icon]="'people'"
                        [attr.data-cy]="'pcExpansion'"
                        class="expansion-panel-m-0"
                    >
                        @for (pcFormGroup of getFormArray('pc')?.controls; track pcFormGroup; let i = $index) {
                            <div class="o-grid__row">
                                <div class="o-grid__field half">
                                    <mds-text-field
                                        id="pc{{ i }}"
                                        [formCtrl]="getFullNameFormControl(pcFormGroup)"
                                        [placeholder]="'Type here...'"
                                        [appearance]="'outline'"
                                        [inputType]="'text'"
                                        [label]="'PC'"
                                        [textFieldWidth]="'100%'"
                                        (input)="emitStringChange($event, { id: 'pc_' + i })"
                                    />
                                </div>
                                <div class="o-grid__field third">
                                    <mds-dropdown
                                        id="pcRegions{{ i }}"
                                        [formCtrl]="getRegionsFormControl(pcFormGroup)"
                                        appearance="outline"
                                        [multiple]="true"
                                        [label]="'Regions'"
                                        [options]="regionsForView"
                                        [placeholder]="'Select region'"
                                        [filterable]="true"
                                        (selectionChange)="regionsSelectionChange($event, 'pc_' + i + '-Regions')"
                                    />
                                </div>
                                <div class="delete-icon">
                                    <mds-icon-button
                                        id="pcTrash{{ i }}"
                                        [icon]="'delete'"
                                        (clickEvent)="removePerson('pc', i)"
                                        [tooltip]="'Delete'"
                                        class="delete-btn danger outline"
                                    ></mds-icon-button>
                                </div>
                            </div>
                        }

                        <ng-container
                            [ngTemplateOutlet]="AddPerson"
                            [ngTemplateOutletContext]="{
                                $implicit: {
                                    roleName: 'pc',
                                },
                            }"
                        />
                    </mds-expansion-panel>
                </div>
            </div>
        }
        @if (this.content?.globalRsm && getFormArray('globalRsm')?.controls) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'Global RSMs'"
                        [description]="''"
                        [icon]="'people'"
                        class="expansion-panel-m-0"
                        [attr.data-cy]="'globalRsmExpansion'"
                    >
                        @for (
                            globalRsmFormGroup of getFormArray('globalRsm')?.controls;
                            track globalRsmFormGroup;
                            let i = $index
                        ) {
                            <div class="o-grid__row">
                                <div class="o-grid__field">
                                    <mds-text-field
                                        id="globalRsm{{ i }}"
                                        [formCtrl]="getFullNameFormControl(globalRsmFormGroup)"
                                        [placeholder]="'Type here...'"
                                        [appearance]="'outline'"
                                        [inputType]="'text'"
                                        [label]="'Global RSM'"
                                        [textFieldWidth]="'100%'"
                                        (input)="emitStringChange($event, { id: 'globalRsm_' + i })"
                                    />
                                </div>
                                <div class="delete-icon">
                                    <mds-icon-button
                                        id="globalRsmTrash{{ i }}"
                                        [icon]="'delete'"
                                        (clickEvent)="removePerson('globalRsm', i)"
                                        [tooltip]="'Delete'"
                                        class="delete-btn danger outline"
                                    ></mds-icon-button>
                                </div>
                            </div>
                        }
                        <ng-container
                            [ngTemplateOutlet]="AddPerson"
                            [ngTemplateOutletContext]="{
                                $implicit: {
                                    roleName: 'globalRsm',
                                },
                            }"
                        ></ng-container>
                    </mds-expansion-panel>
                </div>
            </div>
        }
        @if (this.content?.prm && getFormArray('prm')?.controls) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'PRMs'"
                        [description]="''"
                        [icon]="'people'"
                        [attr.data-cy]="'prmExpansion'"
                        class="expansion-panel-m-0"
                    >
                        @for (prmFormGroup of getFormArray('prm')?.controls; track prmFormGroup; let i = $index) {
                            <div class="o-grid__row">
                                <div class="o-grid__field">
                                    <mds-text-field
                                        id="prm{{ i }}"
                                        [formCtrl]="getFullNameFormControl(prmFormGroup)"
                                        [placeholder]="'Type here...'"
                                        [appearance]="'outline'"
                                        [inputType]="'text'"
                                        [label]="'PRM'"
                                        [textFieldWidth]="'100%'"
                                        (input)="emitStringChange($event, { id: 'prm_' + i })"
                                    />
                                </div>
                                <div class="delete-icon">
                                    <mds-icon-button
                                        id="prmTrash{{ i }}"
                                        [icon]="'delete'"
                                        (clickEvent)="removePerson('prm', i)"
                                        [tooltip]="'Delete'"
                                        class="delete-btn danger outline"
                                    ></mds-icon-button>
                                </div>
                            </div>
                        }
                        <ng-container
                            [ngTemplateOutlet]="AddPerson"
                            [ngTemplateOutletContext]="{
                                $implicit: {
                                    roleName: 'prm',
                                },
                            }"
                        />
                    </mds-expansion-panel>
                </div>
            </div>
        }

        @if (!isClinTrakComparison) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <form [formGroup]="countriesFormGroup">
                        <mds-dropdown
                            id="countriesMultiselectDropdown"
                            [formCtrl]="countriesFormGroup.controls.countriesDropdown"
                            [appearance]="'outline'"
                            [multiple]="true"
                            [closeOnPageScroll]="true"
                            [label]="'Countries'"
                            [options]="countriesForView"
                            [required]="false"
                            [disabled]="false"
                            [placeholder]="'Select country'"
                            [hasSelectAll]="true"
                            [filterable]="true"
                            [autofocusFilter]="false"
                            (selectAllChange)="countriesSelectionChange($event, 'studyCountries')"
                            (selectionChange)="countriesSelectionChange($event, 'studyCountries')"
                        ></mds-dropdown>
                    </form>
                </div>
            </div>

            <div class="o-grid__row">
                <div class="o-grid__field half">
                    <mds-text-field
                        id="numSites"
                        [formGrp]="parentFormGroup"
                        formCtrlName="sitesControl"
                        placeholder="Type here..."
                        appearance="outline"
                        inputType="text"
                        label="Prospected Sites"
                        width="100%"
                        [required]="true"
                        (input)="emitStringChange($event, { id: 'numSites' })"
                    ></mds-text-field>
                </div>
                <div class="o-grid__field half">
                    <mds-text-field
                        id="numPatients"
                        [formGrp]="parentFormGroup"
                        formCtrlName="numPatients"
                        placeholder="Type here..."
                        appearance="outline"
                        inputType="text"
                        label="Prospected Patients"
                        width="100%"
                        [required]="true"
                        (input)="emitStringChange($event, { id: 'numPatients' })"
                    ></mds-text-field>
                </div>
            </div>
            <form [formGroup]="datesFormGroup">
                <div class="o-grid__row">
                    <div class="o-grid__field half">
                        @if (!loaderSpinner) {
                            <medpace-datepicker
                                id="fpfv"
                                appearance="outline"
                                [required]="true"
                                label="FPFV"
                                [formCtrl]="datesFormGroup.controls.dateFPFV"
                                (dateChange)="emitDateChange($event, { id: 'fpfv' })"
                            ></medpace-datepicker>
                        }
                    </div>
                    <div class="o-grid__field half">
                        @if (!loaderSpinner) {
                            <medpace-datepicker
                                id="lplv"
                                appearance="outline"
                                [required]="true"
                                label="LPLV"
                                [formCtrl]="datesFormGroup.controls.dateLPLV"
                                (dateChange)="emitDateChange($event, { id: 'lplv' })"
                            ></medpace-datepicker>
                        }
                    </div>
                </div>
            </form>
            @if (showTravelOptions()) {
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <form [formGroup]="travelOptionsFormGroup">
                            <mds-dropdown
                                [closeOnPageScroll]="false"
                                appearance="outline"
                                label="Travel Options Allowed by the Sponsor"
                                placeholder="Select travel options"
                                [options]="travelOptionsForView"
                                id="travelOptionsDropdown"
                                (selectionChange)="emitTravelOptions($event.value, { id: 'studyTravelOptions' })"
                                [multiple]="true"
                                formCtrlName="travelOptionsDropdown"
                                [formGrp]="travelOptionsFormGroup"
                                [required]="true"
                            ></mds-dropdown>
                        </form>
                    </div>
                </div>
            }
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <h5>Visit Schedule</h5>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="flex flex-row gap-medpace">
                    <mds-button
                        id="MappingVisitsBtn"
                        (clickEvent)="openVisitMappingModal()"
                        label="Mapping"
                        color="primary"
                        [variant]="'outline'"
                        [disabled]="!isValidVisitsFormGroup()"
                    ></mds-button>

                    @if (hasMultipleVisitSchedules) {
                        <mds-button
                            id="AddGroupBtn"
                            (clickEvent)="addVisitScheduleGroup()"
                            label="Add cohort/part"
                            [color]="'primary'"
                            [variant]="'outline'"
                        ></mds-button>
                    }
                </div>
            </div>

            @if (showVisitGroupField) {
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <mds-text-field
                            [formCtrl]="groupNameInput"
                            id="goupNameInput"
                            appearance="outline"
                            label="{{ 'Cohort/Group Name' }}"
                            placeholder="Type here..."
                        ></mds-text-field>
                    </div>
                    <div class="o-grid__field mt-8 flex flex-row gap-medpace">
                        <mds-button
                            id="NewVisitsGroupBtn"
                            (clickEvent)="addVisitGroup()"
                            label="Add"
                            color="primary"
                            [variant]="'outline'"
                        ></mds-button>
                        <mds-button
                            id="CancelVisitsGroupBtn"
                            (clickEvent)="this.showVisitGroupField = false"
                            label="Cancel"
                            color="neutral"
                            [variant]="'outline'"
                        ></mds-button>
                    </div>
                </div>
            }
            @if (cohortExists) {
                <div class="o-grid__row">
                    <medpace-alert [content]="'The cohort name already exists.'" [appearance]="'caution'" />
                </div>
            }
            @if (getVistGroupNamesAsArray().length === 0) {
                <div class="o-grid__row">
                    <medpace-alert [content]="'At least one cohort is expected.'" [appearance]="'danger'" />
                </div>
            }
            <div class="o-grid__row">
                <div class="o-grid__field center-text">
                    <span>Does study have multiple visit schedules?</span>
                </div>
                <div class="o-grid__field">
                    <mds-radio-group
                        [buttons]="radioButtons"
                        [formGrp]="multipleVisitRadioFormGroup"
                        formCtrlName="multipleVisitControl"
                        id="hasMultipleVisitSchedules"
                        (changeEvent)="
                            hasMultipleVisitScheduleRadioChanged($event.value, { id: 'hasMultipleVisitSchedules' })
                        "
                    >
                    </mds-radio-group>
                </div>
            </div>
            @for (groupName of getVistGroupNamesAsArray(); track groupName; let i = $index) {
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <medpace-draggable-list-with-checkboxes
                            id="visitNamesDraggableList{{ i }}"
                            #visitNamesDraggableList
                            [title]="groupName"
                            labelText="visit Name"
                            (optionsChanged)="emitVisitScheduleChange($event, { id: 'visitTypes' }, groupName)"
                            [optionName]="groupName"
                            [index]="i"
                            [options]="getVistNamesByGroupName(groupName)"
                            [hasMultipleVisitSchedules]="content?.hasMultipleVisitSchedules"
                            [parentFormGroup]="parentFormGroup"
                            (tryRemoveOption)="tryRemoveVisitName($event, i)"
                            (tryRemoveGroup)="tryRemoveVisitGroup($event, i)"
                            (removeGroupEvent)="removeVisitGroup($event)"
                            (changeGroupName)="changeGroupName($event)"
                            (isPrimaryChange)="isPrimaryChange($event)"
                        ></medpace-draggable-list-with-checkboxes>
                    </div>
                </div>
            }
            @if (showTravelOptions()) {
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Expense Types</h5>
                            @if (
                                !studyExpenseFormGroup.controls.studyExpenses?.valid &&
                                studyExpenseFormGroup.controls.studyExpenses?.touched
                            ) {
                                <div class="o-grid__row ng-invalid">
                                    <div class="o-grid__field">
                                        <medpace-alert
                                            [content]="studyExpenseFormGroup.controls.studyExpenses.errors?.required"
                                            [appearance]="'danger'"
                                        />
                                    </div>
                                </div>
                            }
                            @for (
                                control of studyExpenseFormGroup.controls.studyExpenses.controls;
                                track control;
                                let i = $index
                            ) {
                                <div id="expense-types">
                                    <mds-checkbox
                                        class="expense-type"
                                        [id]="content?.expenseTypes[i].expenseKey"
                                        [formCtrl]="control"
                                        [label]="content?.expenseTypes[i].expenseDefaultValue"
                                        [name]="content?.expenseTypes[i].expenseKey"
                                        (changeEvent)="checkboxesSelectChanged($event)"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        }
    </div>
} @else {
    @if (loaderSpinner) {
        <div class="o-grid">
            <medpace-loading-card />
        </div>
    } @else {
        <div class="o-grid">
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'Global CTMs'"
                        [description]="''"
                        class="expansion-panel-m-0"
                        icon="people"
                        [attr.data-cy]="'globalCtmExpansion'"
                    >
                        @for (globalCtm of content?.globalCtm; track globalCtm) {
                            <div class="c-info__block">
                                <span>{{ globalCtm.fullName }}</span>
                            </div>
                        }
                    </mds-expansion-panel>
                </div>
            </div>

            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'Regional CTMs'"
                        [description]="''"
                        icon="people"
                        class="expansion-panel-m-0"
                        [attr.data-cy]="'regionalCtmsExpansion'"
                    >
                        @for (regional of content?.regionalCtms; track regional) {
                            <div class="c-info__block">
                                <div class="people-view">
                                    <span style="width: 20%">{{ regional.fullName }}</span>
                                    <span>{{ getRegionNamesByGuid(regional.studyPersonLocales) }}</span>
                                </div>
                            </div>
                        }
                    </mds-expansion-panel>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'PCs'"
                        [description]="''"
                        icon="people"
                        [attr.data-cy]="'pcExpansion'"
                        class="expansion-panel-m-0"
                    >
                        @for (pc of content?.pc; track pc) {
                            <div class="c-info__block">
                                <div class="people-view">
                                    <span style="width: 20%">{{ pc.fullName }}</span>
                                    <span>{{ getRegionNamesByGuid(pc.studyPersonLocales) }}</span>
                                </div>
                            </div>
                        }
                    </mds-expansion-panel>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'Global RSMs'"
                        [description]="''"
                        icon="people"
                        [attr.data-cy]="'globalRsmExpansion'"
                        class="expansion-panel-m-0"
                    >
                        @for (globalRsm of content?.globalRsm; track globalRsm) {
                            <div class="c-info__block">
                                <span>{{ globalRsm.fullName }}</span>
                            </div>
                        }
                    </mds-expansion-panel>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-expansion-panel
                        [panelTitle]="'PRMs'"
                        [description]="''"
                        icon="people"
                        [attr.data-cy]="'prmExpansion'"
                        class="expansion-panel-m-0"
                    >
                        @for (prm of content?.prm; track prm) {
                            <div class="c-info__block">
                                <span>{{ prm.fullName }}</span>
                            </div>
                        }
                    </mds-expansion-panel>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Status</h5>
                        <span>{{ !!content?.status ? content?.status : 'N/A' }}</span>
                    </div>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Indication</h5>
                        <span>{{ !!content?.indication ? content?.indication : 'N/A' }}</span>
                    </div>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Country</h5>
                        <div class="flex flex-wrap">
                            @for (country of sortAsc(content?.studyCountries, 'countryName'); track $index) {
                                <span class="w-1/3 box-border">{{ country.countryName }}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Prospected Sites</h5>
                        <span>{{ content?.numSites }}</span>
                    </div>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Prospected Patients</h5>
                        <span>{{ content?.numPatients }}</span>
                    </div>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>FPFV</h5>
                        <span>{{ content?.fpfv?.toDate() | dateFormat | uppercase }}</span>
                    </div>
                </div>
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>LPLV</h5>
                        <span>{{ content?.lplv?.toDate() | dateFormat | uppercase }}</span>
                    </div>
                </div>
            </div>
            @if (showTravelOptions()) {
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Travel Options</h5>
                            @for (travelOption of content?.studyTravelOptions; track travelOption) {
                                <p>{{ travelOption.name }}</p>
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Visit Schedule</h5>
                        @for (visitGroupName of getVistGroupNamesAsArray(); track visitGroupName) {
                            <div>
                                @if (hasMultipleVisitSchedules) {
                                    <h6>{{ visitGroupName }}</h6>
                                }
                                @for (visit of getVistNamesByGroupName(visitGroupName); track visit) {
                                    <div style="display: flex">
                                        <div class="visits-width" data-cy="visitName">{{ visit.name }}</div>
                                        <div class="visits-width">
                                            {{ visit.scheduled ? 'Scheduled' : 'Unscheduled' }}
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Expense Types</h5>
                        <div class="flex flex-wrap">
                            @for (
                                expense of sortAsc(getActiveStudyExpenses(), 'expenseDefaultValue');
                                track expense.expenseDefaultValue
                            ) {
                                <span class="w-1/3 box-border">{{ expense.expenseDefaultValue }}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

<ng-template #AddPerson let-context>
    <mds-button
        id="addPersonBtn"
        (clickEvent)="addEmptyPersonControl(context.roleName)"
        label="Add person"
        color="primary"
        [variant]="'outline'"
        icon="person_add"
    ></mds-button>
</ng-template>
